export default __webpack_public_path__ + "static/media/juneVol3Issue1.78adcdbd.png";